module.exports = __webpack_public_path__ + "img/internet_connected_light.f29f6a47.svg";